import { render, staticRenderFns } from "./ShiftWork.vue?vue&type=template&id=35f2f2b8&scoped=true&"
import script from "./ShiftWork.vue?vue&type=script&lang=js&"
export * from "./ShiftWork.vue?vue&type=script&lang=js&"
import style0 from "./ShiftWork.vue?vue&type=style&index=0&id=35f2f2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2f2b8",
  null
  
)

export default component.exports